module.exports = __webpack_public_path__ + "img/DJI_0032.cc7c2bed.jpg";